import { render, staticRenderFns } from "./DashboardSidebar.vue?vue&type=template&id=44b336ad&scoped=true&"
import script from "./DashboardSidebar.vue?vue&type=script&lang=js&"
export * from "./DashboardSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b336ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b336ad')) {
      api.createRecord('44b336ad', component.options)
    } else {
      api.reload('44b336ad', component.options)
    }
    module.hot.accept("./DashboardSidebar.vue?vue&type=template&id=44b336ad&scoped=true&", function () {
      api.rerender('44b336ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/layouts/Dashboard/partials/DashboardSidebar.vue"
export default component.exports